export default {"src":"/_next/static/media/BXMT.16ee1937.svg","height":18,"width":18};